import { 
    BOARD_HEIGHT, BOARD_WIDTH, 
    DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP,
    ENTITY_TYPE_CHARACTER
} from "./constants.js";

export class Utilities {
    static adjustPosition = (position, direction) => {
        const adjusted = {
            x: position.x,
            y: position.y
        }

        switch(direction) {
            case DIRECTION_DOWN:
                adjusted.y++
                break;
            case DIRECTION_UP:
                adjusted.y--
                break;
            case DIRECTION_RIGHT: 
                adjusted.x++
                break;
            case DIRECTION_LEFT:
                adjusted.x--
                break;
        }

        return adjusted
    }

    // as in d20, d6, etc
    static d(sides) {
        return Math.floor(Math.random() * sides) + 1;
    }

    static randomPosition = (topLeft, bottomRight) => {
        const xDieSize = (bottomRight.x - topLeft.x) + 1
        const xOffset = bottomRight.x - xDieSize

        const yDieSize = (bottomRight.y - topLeft.y) + 1
        const yOffset = bottomRight.y - yDieSize

        // console.info("randomPosition"
        //     , xDieSize,xOffset
        //     , yDieSize,yOffset
        //     , topLeft, bottomRight
        // )
        const retval = {
            x: Utilities.d(xDieSize) + xOffset, 
            y: Utilities.d(yDieSize) + yOffset,
            // x: d(2) - 1, 
            // y: d(2) - 1,
            // x: 0, y: 0
        }

        return retval
    }

    // Fisher-Yates implementation from: https://stackoverflow.com/a/2450976
    static shuffle(deck) {
        let currentIndex = deck.length;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {

            // Pick a remaining element...
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [deck[currentIndex], deck[randomIndex]] = [
            deck[randomIndex], deck[currentIndex]];
        }

        return deck
    }

    static entityAtPosition = (entities, position) => {
        if(!entities) return false
        const found = entities.find(entity => {
            if(position.x === entity.position.x && position.y === entity.position.y) {
                if(entity.entityType === ENTITY_TYPE_CHARACTER) {
                    return entity.isAlive()
                }

                return true
            }

            return false
        })

        if(found === undefined) { 
            return false
        }

        return found
    }

    static partierAtPosition = (partiers, position) => Utilities.entityAtPosition(partiers, position)
    static adversaryAtPosition = (adversaries, position) => Utilities.entityAtPosition(adversaries, position) 
    static terrainAtPosition = (terrain, position) => Utilities.entityAtPosition(terrain, position)

    static xInBounds = x => x >= 0 && x < BOARD_WIDTH
    static yInBounds = y => y >= 0 && y < BOARD_HEIGHT
    static positionInBounds = position => {
        return Utilities.xInBounds(position.x) && Utilities.yInBounds(position.y)
    }

    static adversaryAtPosition = (adversaries, position) => Utilities.entityAtPosition(adversaries, position) 
    static partierAtPosition = (partiers, position) => Utilities.entityAtPosition(partiers, position)
    static terrainAtPosition = (terrain, position) => Utilities.entityAtPosition(terrain, position)

}